function displayLocale(locale: string): string {
  const base = (locale || 'en').toLowerCase().split('-')[0]
  return base === 'en' ? 'en-GB' : base
}

export function toValidDate(value?: string | Date | null): Date | null {
  if (!value) return null
  const d = value instanceof Date ? value : new Date(value)
  return Number.isNaN(d.getTime()) ? null : d
}

/** Day-first short date, e.g. "16 Feb 2026" / "16 févr. 2026". */
export function formatTableDate(
  value: string | Date | null | undefined,
  locale: string
): string {
  const d = toValidDate(value)
  if (!d) return '—'
  return d.toLocaleDateString(displayLocale(locale), {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
}

/** Full date for tooltips, e.g. "Monday 16 February 2026". */
export function formatLongDate(
  value: string | Date | null | undefined,
  locale: string
): string {
  const d = toValidDate(value)
  if (!d) return ''
  return d.toLocaleDateString(displayLocale(locale), {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
}
